export const DEFAULT_MAP_CONFIG = {
  zoom: 12,
  center: [40.7128, -74.006] as [number, number],
  markerColor: "#2563EB",
  height: "500px",
};

export const getGoogleMapsApiKey = () => import.meta.env.VITE_GOOGLE_API_KEY || "";

export const hasGoogleMapsApiKey = () => !!getGoogleMapsApiKey();

export const REQUIRED_GOOGLE_MAPS_LIBRARIES = ["places", "geocoding"];
